import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestTestSamples } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTTESTSAMPLE,
  DELETE_LABREQUESTTESTSAMPLE,
  GET_LABREQUESTTESTSAMPLES,
  UPDATE_LABREQUESTTESTSAMPLE
} from "./actionTypes";
import {
  addLabRequestTestSampleFail,
  addLabRequestTestSampleSuccess,
  deleteLabRequestTestSampleFail,
  deleteLabRequestTestSampleSuccess,
  getLabRequestTestSamplesFail,
  getLabRequestTestSamplesSuccess,
  setState,
  updateLabRequestTestSampleFail,
  updateLabRequestTestSampleSuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestTestSamples( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, labRequestTestSamples, params.toString());
    yield put(setState(false))
    yield put(getLabRequestTestSamplesSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestTestSamplesFail(error));
  }
}

function* updateLabRequestTestSample ({payload: labRequestTestSampleObj }) {
  try {
    const {id, recordStatus, ...rest} = labRequestTestSampleObj
    const response1 = yield call(patchApiCall, `${labRequestTestSamples}/${id}` , rest);
    yield put(updateLabRequestTestSampleSuccess(response1));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestTestSampleFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestTestSample ({payload: labRequestTestSampleObj}) {
  try {
    yield call(deleteApiCall,`${labRequestTestSamples}/${labRequestTestSampleObj.id}` );
    yield put(deleteLabRequestTestSampleSuccess(labRequestTestSampleObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestTestSampleFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestTestSample ({ payload: labRequestTestSample}) {
  try {
    const response = yield call(postApiCall, labRequestTestSamples ,labRequestTestSample);
    yield put(addLabRequestTestSampleSuccess(response));
    toast.success('Registro agregado correctamente')
    // Tiny delay before reload to let SQL Server persist the loop records
    yield call(() => new Promise(resolve => setTimeout(resolve, 800)));
    yield put({
      type: GET_LABREQUESTTESTSAMPLES,
      payload: { params: `?limit=20&page=0&labRequestTest=${labRequestTestSample.labRequestTest}` }
    });
  } catch (error) {
    yield put(addLabRequestTestSampleFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* labRequestTestSamplesSaga() {
  yield takeEvery(GET_LABREQUESTTESTSAMPLES, fetchLabRequestTestSamples);
  yield takeEvery(ADD_NEW_LABREQUESTTESTSAMPLE, postingLabRequestTestSample);
  yield takeEvery(UPDATE_LABREQUESTTESTSAMPLE, updateLabRequestTestSample);
  // yield takeEvery(UPDATE_LABREQUESTTESTSAMPLE, updateLabRequestTestSampleStatus);
  yield takeEvery(DELETE_LABREQUESTTESTSAMPLE, deleteLabRequestTestSample);
}

export default labRequestTestSamplesSaga;
